import React from 'react';
import { PRICE } from '../data/content';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-24" data-id="element-97" data-mp="vghi7rluohq2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-98" data-mp="19epcfrri54xj">
        <h2 className="font-display text-[1.9rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-99" data-mp="19ga5te22yhtt">
          Bereit, Mathematik <span className="italic text-brand" data-id="element-100" data-mp="1jd50tmz5a03c">einfacher</span> zu unterrichten?
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-101" data-mp="1jasc8qyvsrhb">
          6 Bände + 5 exklusive Boni — sofort einsetzbar, für nur{' '}
          <span className="font-bold text-brand" data-id="element-102" data-mp="1t2ew1bpabyvo">{PRICE}</span>.
        </p>
        <CtaButton className="mt-6 w-full sm:w-auto" data-id="element-103" data-mp="1o4wjlbc271ix" />
      </div>
    </section>;
}